import { Box, IconButton, Button, TextField, Typography } from '@mui/material';

// Use unified date utils
import { moment } from '../../utils/dateUtils';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { button } from '../../static/theme-styles';

const styles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 1,
};

const DateSwitcher = ({ date, setDate, mode = 'day', maxDate = null }) => {
  const getUnit = () => {
    switch (mode) {
      case 'week': return 'week';
      case 'month': return 'month';
      default: return 'day';
    }
  };

  const next = () => {
    const nextDate = moment(date).add(1, getUnit()).format();
    // Restrict next if maxDate is set
    if (maxDate && moment(nextDate).isAfter(moment(maxDate), getUnit())) {
      return;
    }
    setDate(nextDate);
  };

  const prev = () => {
    const prevDate = moment(date).subtract(1, getUnit()).format();
    setDate(prevDate);
  };

  const today = () => {
    const todayDate = moment().format();
    setDate(todayDate);
  };

  // Format label based on mode
  const getLabel = () => {
    switch (mode) {
      case 'week':
        const startOfWeek = moment(date).startOf('week');
        const endOfWeek = moment(date).endOf('week');
        return `${startOfWeek.format('MMM D')} - ${endOfWeek.format('MMM D, YYYY')}`;
      case 'month':
        return moment(date).format('MMMM YYYY');
      default:
        return moment(date).format('dddd');
    }
  };

  // Button text based on mode
  const getButtonText = () => {
    switch (mode) {
      case 'week': return 'This Week';
      case 'month': return 'This Month';
      default: return 'Today';
    }
  };

  return (
    <Box sx={styles}>
      <IconButton onClick={prev}>
        <ChevronLeftIcon />
      </IconButton>

      {mode === 'day' ? (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label={getLabel()}
            value={date}
            maxDate={maxDate ? moment(maxDate).format() : undefined}
            onChange={(newDate) => setDate(moment(new Date(newDate)).format())}
            renderInput={(params) => <TextField size="small" {...params} />}
          />
        </LocalizationProvider>
      ) : (
        <Box sx={{ 
          minWidth: 200, 
          textAlign: 'center',
          py: 1,
          px: 2,
          bgcolor: '#fff',
          borderRadius: 1,
          border: '1px solid #ccc',
        }}>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            {getLabel()}
          </Typography>
        </Box>
      )}

      <IconButton onClick={next}>
        <ChevronRightIcon />
      </IconButton>

      <Button variant="contained" onClick={today} sx={button('secondary')}>
        {getButtonText()}
      </Button>
    </Box>
  );
};

export default DateSwitcher;
